// extracted by mini-css-extract-plugin
export default {"contentContainer":"pWCgKE","description":"TMPSHh","secondaryDescription":"li89aL","content":"vBor8V","imageArea":"LrXUhI","button":"EdMurP"};